export default __webpack_public_path__ + "static/media/dummy.5ecb7e51.jpg";